module.exports = __webpack_public_path__ + "static/img/icon-02.57c6c3c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/how-to-books/icon-02.png
// module id = wZFc
// module chunks = 1